export const trackButtonClick = (name, data = {}) => {
	const { eventName, eventProperties } = getEventNameAndProperties(name, ".ButtonClick", data);
	trackAmplitude(eventName, eventProperties)
}

export const trackLinkClick = (name, data = {}) => {
	const { eventName, eventProperties } = getEventNameAndProperties(name, ".LinkClick", data);
	trackAmplitude(eventName, eventProperties)
}

export const trackEvent = (name, data = {}) => {
	const { eventName, eventProperties } = getEventNameAndProperties(name, ".Event", data);
	trackAmplitude(eventName, eventProperties)
}

export const trackError = (name, data = {}) => {
	const { eventName, eventProperties } = getEventNameAndProperties(name, ".Error", data);
	trackAmplitude(eventName, eventProperties)
}

export const trackABTestAction = (name, idTest, variantName, data = {}) => {
	const { eventName, eventProperties } = getEventNameAndProperties(name, ".ABTest", { idTest, variantName, ...data });
	trackAmplitude(eventName, eventProperties)
}


// export const trackABTestRevenueAction = (idTest, price, optionName, variantName, productId) => {
// 	const eventProperties = { idTest, optionName, variantName };
// 	// const eventProperties = { idTest, optionName, variantName, $revenue: parseFloat(price) / 100 };
// 	logRevenueAmplitude(price, productId, "Price test", eventProperties)
// }

export const setUserId = (id) => {
	window.amplitude && amplitude.getInstance().setUserId(id)
}

export const setUserProperties = (properties) => window.amplitude && amplitude.getInstance().setUserProperties(properties)


const trackAmplitude = (eventName, eventProperties) => {
	window.amplitude && amplitude
		.getInstance()
		.logEvent(eventName, eventProperties);
}

// Doesn't seem to be working - Amplitude receives the event, but Revenue LTV chart doesn't display them
// const logRevenueAmplitude = (price, productId, revenueType, eventProperties, decToAdd = 2) => {
// 	if (window.amplitude) {
// 		// console.log(instance, instance.Revenue)
// 		const priceFloat = parseFloat(price) * 1 / Math.pow(10, decToAdd)
// 		const revenue = new amplitude.Revenue()
// 			.setProductId(productId)
// 			.setPrice(priceFloat)
// 			.setQuantity(1)
// 			.setRevenueType(revenueType)
// 			.setEventProperties(eventProperties)
// 		amplitude.getInstance().logRevenueV2(revenue);
// 	}
// }



function getEventNameAndProperties(name, postFix, data) {
	const eventProperties = JSON.stringify(data);
	const eventName = name + postFix;
	return { eventName, eventProperties };
}
// export const userPropertiesBuilder = () => new userPropertiesBuilderClass();


// For Google Tag Manager, if I will ever use it
// const trackGTM = (eventName, eventProperties) => {
// 	window.dataLayer = window.dataLayer || [];
// 	dataLayer.push({
// 		'event': eventName,
// 		'data': eventProperties
// 	})
// }

// class userPropertiesBuilderClass {
// 	constructor() {
// 		identify = new amplitude.Identify()
// 	}

// 	set(key, value) {
// 		this.identify.set(key, value)
// 		return this
// 	}

// 	unset(key) {
// 		this.identify.unset(key)
// 		return this
// 	}

// 	buildAndCommit(){
// 		ampProject.identify(this.identify)
// 	}
// }